import { cn } from '~/lib/utils';
import Stack from './ui/Stack';

export function FormAction({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className="contents sm:flex justify-end flex-1">
      <div
        className={cn(
          'flex justify-end mt-auto pt-8 gap-4 sm:pt-0 [&>button]:w-full sm:[&>button]:min-w-50',
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}

export function FormBody({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Stack col gap={4} className={cn('flex-1', className)}>
      {children}
    </Stack>
  );
}
